/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */

import React, { useCallback, useContext, useEffect, useRef, useState } from 'react'
import CardHeader from '../../../../../components/CardHeader'
import { useNavigate, useParams } from 'react-router-dom';
import { GetBranchId } from '../../../../../CommonMethods/GetBranchId';
import { dataService } from '../../../../../services/data.services';
import DropDownComponent from '../../../PromoteStudent/Components/DropDownComponent';
import CustomOverLay from '../../../../../components/CustomOverlay';
import AnimatedModel from '../../../../../components/Animation/AnimatedModel';
import ConfirmationPrompt from '../../../../../components/ConfirmationPrompt';
import { generateRandomNumber } from '../../../../../CommonMethods/generateRandomNumber';
import Toast from '../../../../../components/Toast';
import GlobalContext from '../../../../../components/Context/GloablContext';
import ConfirmationModel from '../../../../../components/ConfirmationModel';
import Input from '../../../../../components/InputBox';
import { useOnClickOutside } from '../../../../../CommonMethods/OutsideClick';
import moment from 'moment';
import UpdateButton from '../../../../../components/UpdateButton';

export default function ProcessTransfer() {
    const location = useNavigate();
    const { setToastmessage } = useContext(GlobalContext);
    const [loading, setLoading] = useState(true);
    const [submitSelected, setsubmitSelected] = useState(false);
    const [toastErrorMessage, setToastErrorMessage] = useState("")
    const [errorState, setErrorState] = useState(false);
    const [state, setState] = useState({ transfers_type: "Other Section", transfers_to : "" })
    const { transfer_id } = useParams();
    const [loadingButton, setLoadingButton] = useState(false)

    const getPasscode = async () => {
        const branch_id = await GetBranchId();
        const response = await dataService.GetAPI(`transfer-students/process?branch_id=${branch_id}&transfer_id=${transfer_id}`);
        // Get the current date
        const currentDate = moment();
        // Format the date if needed
        const formattedDate = currentDate.format('MMM DD, YYYY');
        setState((prevState) => ({
            ...prevState,
            process_date : formattedDate,
            ...response?.data?.data?.data
        }));
        setLoading(false)
    };

    useEffect(() => {
        getPasscode();
    }, [])

    const handleApprove = async() => {
        setErrorState(false);
        setLoadingButton(true)
        if(state.passcode === undefined || state.passcode.trim() === "") {
            setErrorState(true)
            setToastErrorMessage("Please fill in the mandatory field")
            setLoadingButton(false)
        } else {
            try {
                const branch_id = await GetBranchId();
                
                const response = await dataService.PatchAPI({passcode: state.passcode}, `transfer-students/${transfer_id}/${branch_id}`);
                setToastmessage("Student transfer processed successfully");
                location(-1)
                setLoadingButton(false)
            } catch (error) {
                setToastErrorMessage(error?.response?.data?.message || "Something went wrong")
                if( error?.response?.data?.message === "Invalid Passcode") {
                    setErrorState(true);
                }
                setLoadingButton(false)
            }
        }
    }
    const handleInput = (e, val, idd) => {
        setToastErrorMessage('')
        setErrorState(false)
        const { id, value } = e.target;
        setState((prv) => ({
            ...prv,
            [id]: value,
        }));
    };
    return (
        <>
            <CardHeader noPadding>
                <div
                    class="mainDataCntnrTop shadow-s13"
                    style={{ position: "sticky", position: -"webkit-sticky;" }}
                >
                    <h5 class="pageHeader adderror">
                        Process Transfer
                    </h5>
                    <div class="flex items-center">
                        <button
                            onClick={() => location(-1)}
                            type="button"
                            class="cancl-btn"
                        >
                            Cancel
                        </button>
                        <UpdateButton
                            loading={loadingButton}
                            ButtonName={"Approve"}
                            handleOnCLick={() => {handleApprove()}}
                            classKey={"actn-btn onboardInstitution"}
                        />
                    </div>
                </div>
                {toastErrorMessage !== "" && (
                    <Toast
                        message={toastErrorMessage}
                        type="error"
                        setToastmessage={setToastErrorMessage}
                    />
                )}
                {loading ?
                    <CustomOverLay
                        Active
                        text="Loading..."
                        classKey={`flex flex-col justify-center items-center sidebarOpenedOverlay`}
                    /> :
                    <div>
                        <div className="mainDataCntnrPageDiv scrollBlue_thick">
                            <div className='w-[800px] mx-auto mt-4'>
                                <div className='border border-[#D0D5DD] p-3 rounded'>
                                    <div className='flex -mx-10'>
                                        <div className='w-[60%] pr-4 pl-14'>
                                            <div className='flex'>
                                                <div className='relative flex items-center mb-4 w-full'>
                                                    <label htmlFor="" class="text-f7 font-normal text-[#031624] min-w-[100px] inline-flex">Transferred from</label>
                                                    <p class="text-f7 font-semibold text-[#031624] ml-5" id='transfer_from'>{state?.transferred_from}</p>
                                                    
                                                </div>
                                            </div>
                                            <div className='flex'>
                                                <div className='relative flex items-center mb-4 w-full'>
                                                    <label htmlFor="" class="text-f7 font-normal text-[#031624] min-w-[100px] inline-flex">Student Name</label>
                                                    <p class="text-f7 font-semibold text-[#031624] ml-9" id="student_name">{state?.student_name}</p>
                                                    
                                                </div>
                                            </div>
                                        </div>
                                        <div className='w-[40%] px-4'>
                                            <div className='flex'>
                                                <div className=' flex items-center mb-4 w-full relative'>
                                                    <label htmlFor="process_date" className="text-f7 font-normal text-[#031624] min-w-[110px] inline-flex">Process Date</label>
                                                    <div className="relative w-full" >
                                                        <input
                                                            id='process_date'
                                                            type="text"
                                                            disabled='true'
                                                            className={`inpt-fld w-[165px]`}
                                                            placeholder="Search by Class"
                                                            value={state?.process_date}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='flex'>
                                                <div className=' flex items-center mb-4 w-full relative'>
                                                    <label htmlFor="passcode" className="text-f7 font-normal text-[#031624] min-w-[110px] inline-flex">Transfer ID</label>
                                                    <div className="relative w-full" >
                                                        <input
                                                            id='transfer_id'
                                                            type="text"
                                                            disabled='true'
                                                            className={`inpt-fld w-[165px]`}
                                                            placeholder="Search by Class"
                                                            value={state.transfer_id}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='flex'>
                                                <div className=' flex items-center mb-4 w-full relative'>
                                                    <label htmlFor="passcode" className="text-f7 font-normal text-[#031624] min-w-[110px] inline-flex">Passcode</label>
                                                    <div className="relative w-full" >
                                                        <Input 
                                                            type="text"
                                                            state={state}
                                                            id="passcode"
                                                            maxLength={30}
                                                            handleInput={handleInput}
                                                            submitSelected={submitSelected}
                                                            setsubmitSelected={setsubmitSelected}
                                                            text={"Enter Passcode"}
                                                            placeholder={"Enter Passcode"}
                                                            inputWidth={'w-[165px]'}
                                                            showErrorBorder={errorState}
                                                            isMandatoryField={true}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                }

            </CardHeader>
        </>
    )
}
